"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionPanel = void 0;
var _index = require("../../styles/index.js");
var _index2 = require("../TypeList/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var AccordionPanel = exports.AccordionPanel = (0, _styledComponents["default"])(_index2.TypeList).attrs({
  condensedAll: true,
  listStyleReset: true
}).withConfig({
  displayName: "Panel__AccordionPanel",
  componentId: "sc-jkxemo-0"
})(["color:", ";background-color:", ";padding-block-end:", ";"], (0, _index.cssColorValue)(_index.semanticColors.textBase), (0, _index.cssColorValue)(_index.semanticColors.backgroundBase), (0, _index.cssSpacing)('base', '16px'));